export const formatMilliUsd = (milliUsd: number): string => {
    const dollars = milliUsd / 1000;
    return dollars.toLocaleString("en-US", { style: "currency", currency: "USD" });
};
